'use strict';

var routes = angular.module('gymsystem.routes', []);

routes.config(['$routeProvider',
    function($routeProvider) {
        $routeProvider
            .when('/', {
                template: '<staff-redirect />'
            })
            .when('/logout', {
                redirectTo: '/pages/signin'
            })
            .when('/dashboard', {
                template: '<dashboard />'
            })
            .when('/get-started/:tab?', {
                template: '<get-started />'
            })
            .when('/customers/active', {
                template: '<customer-search></customer-search>',
                reloadOnSearch: false
            })
            .when('/customers/search', {
                template: '<customer-search></customer-search>',
                reloadOnSearch: false
            })
            .when('/customers/add',  {
                template: '',
                resolve: {
                    addCustomer: ['$rootScope', function($rootScope) {
                        $rootScope.addCustomer();
                    }]
                }
            })
            .when('/customer/criminalrecordexcerpt', {
                templateUrl: 'views/criminalrecordexcerpt.html',
                controller: 'CriminalRecordExcerptCtrl'
            })
            .when('/groups', {
                templateUrl: 'views/groups.html'
            })
            .when('/customers/import', {
                templateUrl: 'views/import0.html',
                controller: 'CustomerImportCtrl'
            })
            .when('/customers/remove', {
                templateUrl: 'views/customersremove.html',
                controller: 'CustomersRemoveCtrl'
            })
            .when('/customer/show/:customerId', {
                controller: 'CustomerCtrl',
                templateUrl: 'views/customer.html'
            })
            .when('/customer/journal/:customerId', {
                templateUrl: 'views/journal.html',
                controller: 'JournalCtrl'
            })
            .when('/staff/list', {
                templateUrl: 'views/staffs.html'
            })
            .when('/staff/show/:staffId', {
                templateUrl: 'views/staff.html',
                controller: 'StaffCtrl'
            })
            .when('/staff/add',  {
                template: '',
                resolve: {
                    addStaff: ['$rootScope', function($rootScope) {
                        $rootScope.addStaff();
                    }]
                }
            })
            .when('/todo/mylist', {
                templateUrl: 'views/todo.html',
                controller: 'MyToDoCtrl'
            })
            .when('/todo/all', {
                templateUrl: 'views/todo.html',
                controller: 'AllToDoCtrl'
            })
            .when('/todo/history', {
                templateUrl: 'views/todo.html',
                controller: 'AllToDoCtrl'
            })
            .when('/todo/add',{
                template: '',
                resolve: {
                    addTask: ['$rootScope', function($rootScope) {
                        $rootScope.addTask();
                    }]
                }
            })
            .when('/notifications', {
                templateUrl: 'views/notifications.html'
            })
            .when('/schedule/show/:categoryId', {
                templateUrl: 'views/schedule.html',
                controller: 'ScheduleCtrl'
            })
            .when('/schedule/change', {
                templateUrl: 'views/schedulechange.html',
                controller: 'ScheduleCtrl'
            })
            .when('/schedule/template/:templateId', {
                templateUrl: 'views/scheduletemplate.html',
                controller: 'ScheduleTemplateCtrl'
            })
            .when('/schedule/templates', {
                templateUrl: 'views/scheduletemplates.html',
                controller: 'ScheduleTemplateListCtrl'
            })
            .when('/schedule/workouttypes', {
                templateUrl: 'views/workouttypes.html'
            })
            .when('/schedule/add',  {
                template: '',
                resolve: {
                    addWorkout: ['$rootScope', function($rootScope) {
                        $rootScope.addWorkout();
                    }]
                }
            })
            .when('/settings/resources', {
                templateUrl: 'views/resources.html'
            })
            .when('/settings/checkout', {
                templateUrl: 'views/cashregisters.html'
            })
            .when('/settings/addons', {
                template: '<iframe ng-if="!isExpoApp()" src="/addon/shop.html?added=true&skipurlupdate=true" style="border:0; height: calc(100% - 6px); width: 100%"></iframe><iframe ng-if="isExpoApp()" src="/addon/shop.html?added=true&skipurlupdate=true" style="border:0; height: calc(100% - 6px); width: 100%"></iframe>',
                reloadOnSearch: false
            })
            .when('/addon/shop', {
                template: '<iframe src="/addon/shop.html?skipurlupdate=true" style="border:0; height: calc(100% - 6px); width: 100%"></iframe>',
                reloadOnSearch: false
            })
            .when('/economy/systemcost', {
                templateUrl: 'views/systemcost.html'
            })
            .when('/bookings', {
                templateUrl: 'views/bookings.html'
            })
            .when('/resourcebooking/overview', {
                templateUrl: 'views/resourcebookingoverview.html',
                reloadOnSearch: false
            })
            .when('/resourcebooking/services', {
                templateUrl: 'views/resourcebookingservices.html'
            })
            .when('/resourcebooking/book/:categoryId', {
                templateUrl: 'views/resourcebookingbook.html',
                controller: 'ResourceBookingBookCtrl'
            })
            .when('/resource/show/:staffId', {
                templateUrl: 'views/resource.html',
                controller: 'ResourceCtrl'
            })
            .when('/resourcebooking/unconfirmed', {
                templateUrl: 'views/resourcebookingunconfirmed.html',
                controller: 'ResourceBookingUnconfirmedCtrl'
            })
            .when('/entry/show', {
                templateUrl: 'views/entry.html'
            })
            .when('/pages/externalentry/:doorId?', {
                templateUrl: 'views/xentry.html'
            })
            .when('/attendance', {
                templateUrl: 'views/attendancelist.html',
                controller: 'AttendanceListCtrl'
            })
            .when('/attendance/show/:workoutId', {
                templateUrl: 'views/attendance.html',
                controller: 'AttendanceCtrl'
            })
            .when('/checkout', {
                templateUrl: 'views/checkout.html',
                controller: 'CheckoutCtrl'
            })
            .when('/pages/selfcheckout/:cashierId', {
                templateUrl: 'views/selfcheckout.html',
                controller: 'SelfCheckoutCtrl'
            })
            .when('/statistics/overview', {
                templateUrl: 'views/statistics.html',
                controller: 'StatisticsCtrl'
            })
            .when('/statistics/newreport', {
                templateUrl: 'views/newreport.html'
            })
            .when('/statistics/greports', {
                templateUrl: 'views/statgreports.html'
            })
            .when('/statistics/report/:reportId', {
                templateUrl: 'views/showreport.html'
            })
            .when('/statistics/entrylist', {
                templateUrl: 'views/statisticsentrylist.html',
                controller: 'StatisticsEntryListCtrl'
            })
            .when('/statistics/reports', {
                templateUrl: 'views/reports.html',
                controller: 'ReportCtrl'
            })
            .when('/statistics/eventlog', {
                templateUrl: 'components/eventlog/eventlog.html'
            })
            .when('/payment/directdebit/create', {
                templateUrl: 'views/directdebitcreate.html'
            })
            .when('/payment/directdebit/files', {
                templateUrl: 'views/directdebitfiles.html'
            })
            .when('/payment/directdebit/import', {
                templateUrl: 'views/directdebitimport.html'
            })
            .when('/payment/directdebit/consents', {
                templateUrl: 'views/directdebitconsents.html'
            })
            .when('/payment/directdebit/confirm', {
                templateUrl: 'views/bankgiroconfirm.html'
            })
            .when('/economy/dashboard', {
                template: '<dashboard type="economy" />'
            })
            .when('/economy/loadfile', {
                templateUrl: 'views/economyload.html'
            })
            .when('/economy/accounting', {
                templateUrl: 'views/economyaccounting.html'
            })
            .when('/economy/zoezipayportal', {
                templateUrl: 'views/zoezipayportal.html'
            })
            .when('/economy/invoices', {
                templateUrl: 'views/economyinvoices.html',
                reloadOnSearch: false
            })
            .when('/economy/clientaccount', {
                templateUrl: 'views/economyclientaccount.html'
            })
            .when('/economy/stripe', {
                template: '<economy-stripe-balance></economy-stripe-balance>',
            })
            .when('/economy/budgets', {
                templateUrl: 'views/economybudgets.html'
            })
            .when('/economy/budget/:budgetId', {
                templateUrl: 'views/economybudget.html'
            })
            .when('/settings/gym/:tab?', {
                templateUrl: 'views/gymsettings.html'
            })
            .when('/settings/import', {
                templateUrl: 'views/import.html'
            })
            .when('/settings/sale', {
                templateUrl: 'views/sale.html'
            })
            .when('/settings/memberpage', {
                templateUrl: 'views/memberpagesettings.html'
            })
            .when('/settings/roles', {
                templateUrl: 'views/rolesettings.html'
            })
            .when('/settings/customerstatus', {
                templateUrl: 'views/customerstatus.html'
            })
            .when('/settings/language', {
                templateUrl: 'views/language.html'
            })
            .when('/settings/customerfields', {
                templateUrl: 'views/customerfields.html'
            })
            .when('/admin/bankgiro', {
                templateUrl: 'components/bankgiro/admin.html'
            })
            .when('/pages/resetpassword/:hash', {
                templateUrl: 'views/pages/resetpassword.html'
            })
            .when('/pages/setpassword/:login_key/:hash', {
                templateUrl: 'views/pages/setpassword.html'
            })
            .when('/mailings/all', {
                templateUrl: 'views/mailings.html',
                controller: 'MailingsCtrl'
            })
            .when('/mailings/new', {
                templateUrl: 'views/mailingnew.html',
                controller: 'NewMailingCtrl'
            })
            .when('/mailings/templates/new', {
                templateUrl: 'views/templatenew.html',
                controller: 'NewTemplateCtrl'
            })
            .when('/mailings/automailings', {
                templateUrl: 'views/automailings.html',
                controller: 'AutomaticMailingsCtrl'
            })
            .when('/mailings/automailings/new', {
                templateUrl: 'views/automailingnew.html',
                controller: 'NewGenericAutomaticMailingCtrl'
            })
            .when('/courses', {
                templateUrl: 'views/courses.html'
            })
            .when('/statistics/apn', {
                template: '<apn-component></apn-component>'
            })
            .when('/statistics/lok', {
                template: '<apn-component type="lok"></apn-component>'
            })
            .when('/teamsports/admin', {
                templateUrl: 'views/teamsports.html'
            })
            .when('/teamsports/overview', {
                templateUrl: 'views/teamsportsoverview.html'
            })
            .when('/teamsports/settings', {
                templateUrl: 'views/teamsportssettings.html'
            })
            .when('/teamsport/:teamsportId', {
                templateUrl: 'views/teamsport.html'
            })
            .when('/teamsports/competition/:competitionId', {
                templateUrl: 'views/teamsportcompetition.html'
            })
            .when('/teamsports/gameclass/:gameclassId', {
                templateUrl: 'views/teamsportgameclass.html'
            })
            .when('/teamsports/step/:stepId', {
                templateUrl: 'views/competitionstep.html'
            })
            .when('/teamsports/division/:divisionId', {
                templateUrl: 'views/teamsportdivision.html'
            })
            .when('/teamsports/match/:matchId', {
                templateUrl: 'views/teamsportmatch.html'
            })
            .when('/insurancecheck', {
                templateUrl: 'views/insurancecheck.html',
                controller: 'InsuranceCheckCtrl'
            })
            .when('/settings/proxyapp', {
                templateUrl: 'views/proxyappsettings.html'
            })
            .when('/mobile/close', {
            })
            .when('/support', {
            })
            .otherwise( {
                redirectTo: '/'
            });
}]);
